define('usuario-imoveis-favoritos-controller',['usuario-imoveis-favoritos-resource'], function() {

    var app = angular.module('usuario.imoveis.favoritos.controller', [
        'usuario.imoveis.favoritos.resource'
    ]);

    app.controller('UsuarioImoveisFavoritosControllerIndex', ['$scope', '$rootScope',  'UsuarioImoveisFavoritos',
        function($scope, $rootScope,  UsuarioImoveisFavoritos) {
            $scope.initPagination = function() {
                $scope.itemsPerPage = 5;
                $scope.totalItems = 0;
                $scope.currentPage = 1;
                $scope.pagination = [];
                $scope.$watch('totalItems', function (totalItems) {
                    var page = parseInt(totalItems / $scope.itemsPerPage);
                    if((totalItems % $scope.itemsPerPage) > 0){
                        page++;
                    }
                    var arr = [];
                    for(var i = 1; i<= page; i++){
                        arr.push({page:i});
                    }
                    $scope.pagination = arr;
                });
            }
            $scope.initPagination();
            $scope.imoRelacionados = [];
            $scope.getImoveisFavoritos = function(){
                var data = {
                    pagination:{
                        itemsPerPage: $scope.itemsPerPage,
                        offset: (($scope.currentPage - 1) * $scope.itemsPerPage)
                    }
                };
                UsuarioImoveisFavoritos.getImoveisFavoritos(data).then(function(data) {
                    $scope.itens =  data.itens;
                    $scope.totalItems = data.totalItems;
                    if($scope.imoRelacionados.length == 0) {
                        $scope.imoRelacionados = data.imoveisRelacionados;
                    }
                });
            }
            $scope.getImoveisFavoritos();

            $scope.setPage = function(page){
                $scope.currentPage = page;
                $scope.getImoveisFavoritos();
            }

            $scope.setAvaliacao = function(item, value) {
                UsuarioImoveisFavoritos.setAvaliacao(item, value).then(function (data) {
                    if (data.success) {
                        var idx = _.findIndex($scope.itens, function(o){ return o.imo_codigo == data.item.imo_codigo});
                        $scope.itens[idx].usuif_avaliacao = data.item.usuif_avaliacao;
                        $scope.checkStar($scope.itens[idx]);
                    }
                });
            }
            /*
             Avaliacao check
             Capiroto encarno em mim hj de manhã
             */
            $scope.checkStar = function(item){
                var avaliacao = item.usuif_avaliacao;
                item.star = [false, false, false, false, false];
                if(avaliacao !== 0) {
                    for(var i = (avaliacao - 1);i >= 0; i--){
                        item.star[i] = true;
                    }
                }
            }

            $scope.showContact = false;
            $scope.msgSuccess = false;
            $scope.forma = [{value:'E', nome:'E-mail'},{value:'W', nome:'WhatsApp'}];

            $scope.resetContato = function(){
                $scope.contato = {
                    nome:null,
                    email:null,
                    telefone:null,
                    mensagem:null,
                    forma:"E"
                }
            }
            $scope.resetContato();
            $scope.contactMe = function(op){
                $scope.showContact = true;
                // console.log(op);
                var msg = 'Olá, gostaria de ter mais informações sobre o Imóvel / Empreendimento' + (op.imoc_nome?', '+op.imoc_nome:'') + ' Cód: '+ op.imo_codigo+' - '+op.tic_nome+' - ' + op.ist_nome + ', '+op.cid_nome+' '+op.est_nome;
                msg += ' que encontrei no seu site. Aguardo seu contato, obrigado.';
                var usuario = $rootScope.usuarioLogado;
                $scope.contato = {
                    nome:(usuario.PessoaView != null) ? usuario.PessoaView.pes_nome : usuario.Lead.lead_nome,
                    email:usuario.usu_email,
                    telefone:(usuario.PessoaView != null) ? usuario.PessoaView.pesf_telefone : usuario.Lead.lead_fone,
                    mensagem:msg,
                    forma:"E",
                    imo_codigo:op.imo_codigo
                }
                $scope.enviarContact = function(form){
                    if(form.$valid){
                        UsuarioImoveisFavoritos.enviarContact($scope.contato).then(function(result){
                            if(result.success){
                                $scope.showContact = false;
                                $scope.msgSuccess = 'Enviado com sucesso!';
                                setTimeout(function(){
                                    $scope.$apply(function(){
                                        $scope.msgSuccess = false;
                                    })
                                }, 5000);
                                $scope.getImoveisFavoritos();
                            }
                        });
                    } else {
                        angular.forEach(form.$error.required, function (value, key) {
                            form.$error.required[key].$pristine = false;
                        });
                    }
                }
            }
            $scope.resetLogsForm = function(){
                $scope.logs = {
                    imovel:{
                        imoc_nome:null,
                        imo_codigo:null,
                        tic_nome:null,
                        ist_nome:null,
                        cid_nome:null,
                        est_nome:null
                    },
                    logs:[]
                }
            };
            $scope.showLogs = false;
            $scope.resetLogsForm();
            $scope.getLogs = function(op){
                $scope.showLogs = true;
                $scope.logs.imovel = {
                    imoc_nome:op.imoc_nome,
                    imo_codigo:op.imo_codigo,
                    tic_nome:op.tic_nome,
                    ist_nome:op.ist_nome,
                    cid_nome:op.cid_nome,
                    est_nome:op.est_nome
                };
                UsuarioImoveisFavoritos.getLogs({imo_codigo:op.imo_codigo}).then(function(result){
                    if(result.success) {
                        $scope.logs.logs = result.items;
                    }else{
                        $scope.logs.logs = [];
                    }
                });
            }

            

        }]);

});

